const META_PIXEL_ID = '1077778394733926'

type MetaPixelFunction = {
  (...args: unknown[]): void
  callMethod?: { apply: (context: unknown, args: unknown) => void }
  push?: unknown
  queue?: unknown[]
  loaded?: boolean
  version?: string
}

declare global {
  interface Window {
    fbq?: MetaPixelFunction
    _fbq?: MetaPixelFunction
  }
}

function getPixel(): MetaPixelFunction | undefined {
  if (typeof window === 'undefined') return undefined

  // Another script on the page (host wrapper, checkout provider) may have
  // installed fbq already. Reuse it instead of bailing out, otherwise this
  // pixel would never be initialized at all.
  if (window.fbq) return window.fbq

  const fbq: MetaPixelFunction = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, args)
    } else {
      fbq.queue?.push(args)
    }
  }

  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []

  window.fbq = fbq
  window._fbq = fbq

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  return fbq
}

export function initializeMetaPixel() {
  const fbq = getPixel()
  if (!fbq) return

  fbq('init', META_PIXEL_ID)
  fbq('track', 'PageView')
}

export function trackCheckoutStart() {
  window.fbq?.('trackSingle', META_PIXEL_ID, 'InitiateCheckout')
}
